import React from 'react'
import { useSelector } from 'react-redux'

import AddSubscriptions from '@/components/MainFlow/AddSubscriptions'
import SignAndSubmit from '@/components/MainFlow/SignAndSubmit'
import Receipt from '@/components/MainFlow/Receipt'

const StepsComponent = () => {
  const formData = useSelector((state: any) => state.formData)
  
  return (
    <div className="main-flow-container">
      {formData.step === 'add-subs' && <AddSubscriptions />}
      {formData.step === 'sign-submit' && <SignAndSubmit />}
      {formData.step === 'receipt' && <Receipt />}
    </div>
  )
}

export default StepsComponent
